import { render, staticRenderFns } from "./RecordingRule.vue?vue&type=template&id=47667c63&scoped=true&"
import script from "./RecordingRule.vue?vue&type=script&lang=js&"
export * from "./RecordingRule.vue?vue&type=script&lang=js&"
import style0 from "./RecordingRule.vue?vue&type=style&index=0&id=47667c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47667c63",
  null
  
)

export default component.exports